import React, { memo } from 'react'
import useGlobals from 'sb-hooks/useGlobals'


const injectGlobals = (storeProps: any) => (ComposedComponent: React.ComponentType) => {
  const WrappedComponent = (props) => {
    const data = useGlobals(storeProps)

    return (
      <ComposedComponent
        {...props}
        {...data}
      />
    )
  }

  WrappedComponent.WrappedComponent = ComposedComponent
  WrappedComponent.displayName = `injectGlobals(${ComposedComponent.displayName || ComposedComponent.name})`

  return memo(WrappedComponent)
}


export default injectGlobals
